import App from "@/views/App.vue";

export default [
  {
    path: "/buscar",
    name: "search",
    component: App,
    redirect: { name: "searchHome" },
    children: [
      {
        path: "",
        name: "searchHome",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewSearch.vue"),
        meta: {
          displayName: "Buscar - Exclusive Lounge",
          requiresAuth: true,
        },
      },
      {
        path: "buscar/interesse/:id",
        name: "searchTagId",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewSearchByTag.vue"),
        meta: {
          displayName: "Buscar por interesse - Exclusive Lounge",
          requiresAuth: true,
        },
      },
      {
        path: "/nova-busca",
        name: "newSearchHome",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewSearch.vue"),
        meta: {
          displayName: "Buscar - Exclusive Lounge",
          requiresAuth: true,
        },
      },
      {
        path: "buscar/interesse-novo/:id",
        name: "newSearchTagId",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewSearchByTag.vue"),
        meta: {
          displayName: "Buscar por interesse - Exclusive Lounge",
          requiresAuth: true,
        },
      },
    ],
  },
];
